var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      ref: "multipleTable",
      staticStyle: { width: "100%" },
      attrs: {
        data: _vm.tableData,
        height: "100%",
        border: true,
        "header-cell-style": { color: "#333333", background: "#EFF6FF" },
        "tooltip-effect": "dark",
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          prop: "id",
          align: "center",
          label: "客户 ID",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.id || "-") + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "fullname",
          align: "center",
          label: "客户名称",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.fullname || "-") + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "mobile",
          align: "center",
          label: "客户电话",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.mobile || "-") + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "name",
          align: "center",
          label: "城市仓",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      (scope.row.logistics && scope.row.logistics.name) || "-"
                    )
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "shopname",
          align: "center",
          label: "店铺名称",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.shopname || "-") + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "industry",
          align: "center",
          label: "从事行业",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.professionName(scope.row.industry)) + " "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "create_time",
          align: "center",
          label: "注册时间",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.create_time || "-") + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "days",
          align: "center",
          label: "注册天数",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "average_order_day_qty",
          align: "center",
          label: "日均下单件数",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "order_qty",
          align: "center",
          label: "下单总件数",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "labels",
          align: "center",
          label: "标签",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(" " + _vm._s(_vm.labelstitle(scope.row.labels)) + " "),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "star_customer_grade_detail",
          align: "center",
          label: "客户等级",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "purchase_hierarchy",
          align: "center",
          label: "客户购买能力",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "customer_activity_txt",
          align: "center",
          label: "客户活跃度",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "customer_status_txt",
          align: "center",
          label: "客户下单状态",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "black_status",
          align: "center",
          label: "客户状态",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.black_status_txt) + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "logistic_business_name",
          align: "center",
          label: "集配中心",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          fixed: "right",
          label: "操作",
          "min-width": "240",
          align: "center",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.onHandleStatus(scope.row)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        `${
                          scope.row.black_status ? "移出黑名单" : "加入黑名单"
                        }`
                      )
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.CustomerDetails(scope.row)
                      },
                    },
                  },
                  [_vm._v("查看详情")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.addlabel(scope.row)
                      },
                    },
                  },
                  [_vm._v("设置标签")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }